<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap">
                <div class="breadcrumbnew mr-4">
                    <span>Sales</span>
                    <span>Sales Forecasting</span>
                    <a>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1">
                        <i class="icon icon-magnify icondefault"
                            style="border-radius: 20px 0px 0px 20px; padding: 8px 16px; height: 37px;"></i>
                        <input class="w-100" type="text" v-model="search_key"
                            placeholder="Search by Sales Forecast ID, Sales Type, Company Name, Sales Person"
                            style="border-radius: 0px 20px 20px 0px; padding-left: 10px;">
                    </div>
                </div>
            </div>
            <div class="design-block pl-15 pr-15 pt-0">
                <h2 class="headerblock pt-0 pb-0">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <form class="form-inline">
                                <router-link :disabled="!$routerHistory.hasPrevious()"
                                    :to="{ path: $routerHistory.previous().path }">
                                    <el-tooltip class="item pull-left" effect="dark" content="Click to Go Back"
                                        placement="top">
                                        <button class="router mr-3 mt-5 mb-5">
                                            <i class="icons icon-arrow-left text-white"></i>
                                        </button>
                                    </el-tooltip>
                                </router-link>
                                <router-link :disabled="!$routerHistory.hasForward()"
                                    :to="{ path: $routerHistory.next().path }">
                                    <el-tooltip class="item pull-left" effect="dark" content="Click to Go Forward"
                                        placement="top">
                                        <button class=" router mr-7 mt-5 mb-5">
                                            <i class="icons icon-arrow-right text-white"></i>
                                        </button>
                                    </el-tooltip>
                                </router-link>
                                <a href="javascript:;" class="btn btn-new-green btn-wide mr-6 mt-5 mb-5"
                                    @click="createSaleForecast()">+ Create New</a>
                                <a href="javascript:;" class="btn btn-new-primary btn-des mr-4 mt-5 mb-5"
                                    @click="openFilters()">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" alt="filter"
                                        style="margin-right: 8px;" />Filter
                                </a>
                            </form>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="pagination-footer pull-right mt-5 mb-5" style="margin-top: 4px;">
                                <input class="text-center" type="text" v-model.number="limit"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="getListData"
                                    style="min-height: 30px; width: 46px; border: solid 2px rgba(103, 103, 103, 0.84); border-radius: 5px; padding-right: 22px;position:relative;bottom:2px;" />
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                                    style="margin-left: -20px;">
                                <span class="page-info pr-2 pl-2 fw-500"
                                    style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;position:relative;bottom:2px;">Per
                                    page</span>
                                <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                        <i class="icon-chevron-double-left"></i>
                                    </el-tooltip>
                                </button>
                                <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                        <i class="icon icon-chevron-left"></i>
                                    </el-tooltip>
                                </button>
                                <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} -
                                    {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                                <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                        <i class="icon icon-chevron-right"></i>
                                    </el-tooltip>
                                </button>
                                <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                        <i class="icon-chevron-double-right"></i>
                                    </el-tooltip>
                                </button>
                            </div>
                        </div>
                    </div>
                </h2>
                <div class="filterblock mb-5" v-if="filterblock">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="d-flex flex-row flex-wrap">
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'company' }"
                                @click="selectedFilter = 'company'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Company</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>
                                            <span class="filterheader">Select Company</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="selectCompany = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" @close="updateBranch"
                                                @select="clearData" @search-change="fetchCustomers" :loading="isLoading"
                                                v-model="selectCompany" :searchable="true" placeholder="Type to Search"
                                                label="company_name" track-by="_id" :options="customers"
                                                :multiple="true" :taggable="false" :close-on-select="false"
                                                :show-labels="false" :clear-on-select="false" open-direction="bottom">
                                                <template slot="noOptions">
                                                    <div class="text-center d-block text-secondary fw-600">Companies Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-center d-block text-secondary fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'branch' }"
                                @click="selectedFilter = 'branch'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Branch</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="branch-el">
                                        <el-dropdown-item>
                                            <span class="filterheader">Select Branch</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="branchName = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" @close="updateDept"
                                                :loading="isLoading" v-model="branchName" :searchable="true"
                                                placeholder="Type to Search" label="name" track-by="_id"
                                                :options="branchs" :multiple="true" :taggable="false"
                                                :close-on-select="false" :show-labels="false" :clear-on-select="false"
                                                open-direction="bottom">
                                                <template slot="noOptions">
                                                    <div class="text-center d-block text-secondary fw-600">Branches Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-center d-block text-secondary fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'department' }"
                                @click="selectedFilter = 'department'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Department</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="department-el">
                                        <el-dropdown-item>
                                            <span class="filterheader">Select Department</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="departmentName = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" :loading="isLoading"
                                                v-model="departmentName" :searchable="true" placeholder="Type to Search"
                                                :options="departments" :multiple="true" :taggable="false"
                                                :close-on-select="false" :show-labels="false" :clear-on-select="false"
                                                open-direction="bottom">
                                                <template slot="noOptions">
                                                    <div class="text-center d-block text-secondary fw-600">Departments Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-center d-block text-secondary fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'sales' }"
                                @click="selectedFilter = 'sales'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Sales Person</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="sales-person-el">
                                        <el-dropdown-item>
                                            <span class="filterheader">Sales Person</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="salesPerson = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" :loading="isLoading"
                                                v-model="salesPerson" @search-change="fetchSalesPerson"
                                                @close="skip = 0;search_key = ''" :searchable="true"
                                                placeholder="Type to Search" :options="salesperson" label="full_name"
                                                track-by="_id" :multiple="true" :taggable="false"
                                                :close-on-select="false" :show-labels="false" :clear-on-select="false"
                                                shortcuts="false" open-direction="bottom">
                                                <template slot="afterList">
                                                    <div v-observe-visibility="fetchSalesPersonAfter" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-center d-block text-secondary fw-600">Sales Persons Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-center d-block text-secondary fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'fiscal_year' }"
                                @click="selectedFilter = 'fiscal_year'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Fiscal Year</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="fiscal-year-el">
                                        <el-dropdown-item class="d-flex justify-content-between align-items-center">
                                            <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                                            <span style="font-size: 12px; font-weight: 400">{{years_to_set[0]}} -
                                                {{years_to_set[5]}}</span>
                                            <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            class="d-flex flex-column justify-content-center align-items-center">
                                            <span
                                                :class="{ 'selectedYear':fiscalYear == `${years_to_set[0]}-${years_to_set[1]}` }"
                                                @click="yearClicked(years_to_set[0], years_to_set[1])">{{years_to_set[0]}}
                                                - {{years_to_set[1]}}</span>
                                            <span
                                                :class="{ 'selectedYear':fiscalYear == `${years_to_set[1]}-${years_to_set[2]}` }"
                                                @click="yearClicked(years_to_set[1], years_to_set[2])">{{years_to_set[1]}}
                                                - {{years_to_set[2]}}</span>
                                            <span
                                                :class="{ 'selectedYear':fiscalYear == `${years_to_set[2]}-${years_to_set[3]}` }"
                                                @click="yearClicked(years_to_set[2], years_to_set[3])">{{years_to_set[2]}}
                                                - {{years_to_set[3]}}</span>
                                            <span
                                                :class="{ 'selectedYear':fiscalYear == `${years_to_set[3]}-${years_to_set[4]}` }"
                                                @click="yearClicked(years_to_set[3], years_to_set[4])">{{years_to_set[3]}}
                                                - {{years_to_set[4]}}</span>
                                            <span
                                                :class="{ 'selectedYear':fiscalYear == `${years_to_set[4]}-${years_to_set[5]}` }"
                                                @click="yearClicked(years_to_set[4], years_to_set[5])">{{years_to_set[4]}}
                                                - {{years_to_set[5]}}</span>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm mt-2 mb-4"
                                                @click="getFilteredListData">Apply</a>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="close" @click="closeFilters">
                            <p>&times;</p>
                        </div>
                    </div>
                </div>
                <div v-else-if="!filterblock && selectCompany.length || branchName.length || departmentName.length || salesPerson.length || fiscalYear"
                    class="d-flex align-items-center flex-wrap mb-5">
                    <span class="filers_added" v-for="company in selectCompany"
                        :key="company._id">{{ company.company_name }}<i class="icon icon-close ml-4 pointer"
                            @click="removeCompany(company)"></i></span>
                    <span class="filers_added" v-for="branch in branchName" :key="branch._id">{{ branch.name }}<i
                            class="icon icon-close ml-4 pointer" @click="removeBranch(branch)"></i></span>
                    <span class="filers_added" v-for="(department,index) in departmentName"
                        :key="index">{{ departmentName[index] }}<i class="icon icon-close ml-4 pointer"
                            @click="removeDepartment(department)"></i></span>
                    <span class="filers_added" v-for="salesPerson in salesPerson"
                        :key="salesPerson._id">{{ salesPerson.full_name }}<i class="icon icon-close ml-4 pointer"
                            @click="removeSalesPerson(salesPerson)"></i></span>
                    <span class="filers_added" v-if="fiscalYear">{{ fiscalYear }}<i class="icon icon-close ml-4 pointer"
                            @click="fiscalYear = ''"></i></span>
                    <span
                        style="color: #e82828; font-size: 16px; text-decoration: underline; cursor: pointer; margin-left: 15px;"
                        @click="removeAllFilters">Clear All</span>
                </div>
                <div style="overflow-x: auto">
                    <table class="table table-new-template">
                        <thead>
                            <tr>
                                <th class="head">SALESFORECAST ID</th>
                                <th class="head">COMPANY NAME</th>
                                <th class="head">BRANCH NAME</th>
                                <th class="head">DEPARTMENT NAME</th>
                                <th class="head">FISCAL YEAR</th>
                                <th class="head">SALES TYPE</th>
                                <th class="head">SALES PERSON</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="ajaxCallinprogress && !listTable.length">
                                <td colspan="7">
                                    <div class="d-flex align-items-center justify-content-center h-100">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                            style="margin: 0 auto;" />
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="!listTable.length && !ajaxCallinprogress" id="tableNoData">
                                <td colspan="7">No Sales Forecast Found</td>
                            </tr>
                            <tr v-else v-for="(sales,index) in listTable" :key="index">
                                <td :title="sales.sales_forecast_id || '-'">{{sales.sales_forecast_id || "-" }}</td>
                                <td :title="sales.company_name || '-'">
                                    <span style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block;">
                                        {{sales.company_name || "-"}}
                                    </span>
                                </td>
                                <td :title="sales.branch_name || '-'">{{sales.branch_name || "-"}}</td>
                                <td :title="sales.department || '-'">{{sales.department || "-"}}</td>
                                <td>{{sales.target_year || "-"}}</td>
                                <td
                                    :title="sales.sales_type == 'forecast' ? 'Forecast for Year' : 'Current Sales for Year' || '-'">
                                    {{sales.sales_type == 'forecast' ? 'Forecast for Year' : 'Current Sales for Year' || "-"}}
                                </td>
                                <td class="td-last">{{sales.sales_person_name || "-"}}</td>
                                <td class="td-admin" style="padding: 0.2rem 1.2rem !important;">
                                    <div class="pointer">
                                        <el-tooltip class="item" effect="dark" content="View" placement="top">
                                            <button class="btn-icon p-1"
                                                style="margin-right: 5px;margin-top: 5px;vertical-align: middle;">
                                                <i class="icon icon-eye eyeIcon item text-secondary iconsize-18"
                                                    @click="viewCompany(sales.sales_id)"></i>
                                            </button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                            <button class="btn btn-icon actionicons p-1" @click="editCompany(sales.sales_id)">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/edit.svg" style="width: 16px;margin-right: 20px;" />
                                            </button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                                            <button class="btn btn-icon actionicons" @click="deletSales(sales.sales_id)">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash.svg" style="width: 12px;" />
                                            </button>
                                        </el-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import customer from "./mixins/customer";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    export default {
        mixins: [customer],
        data() {
            return {
                start: 0,
                end: 0,
                total: 0,
                limit: 10,
                skip: 0,
                count: 0,
                skip_temp: 0,
                temp_total: 0,
                search_key: "",
                filterblock: false,
                selectCompany: [],
                customers: [],
                branchName: [],
                branchs: [],
                departmentName: [],
                departments: [],
                fiscalYear: "",
                years_to_set: [],
                salesPerson: [],
                salesperson: [],
                ajaxCallinprogress: false,
                isLoading: false,
                hide_el_dropdown: false,
                selectedFilter: "",
                listTable: [],
            };
        },
        components: {
            HalfCircleSpinner,
        },
        methods: {
            createSaleForecast() {
                this.$router.push({
                    name: "CreateSalesForecast"
                });
            },
            openFilters() {
                this.filterblock = true;
            },
            closeFilters() {
                this.filterblock = false;
            },
            updateBranch() {
                if (this.selectCompany.length && this.selectCompany) {
                    this.branchs = [];
                    let comp_name = [...new Set(this.selectCompany.map(x => x.company_name))];
                    let params = {
                        company_name: comp_name[0],
                    };
                    this.$http.post("shadow_companies/get_branches", params).then(res => {
                        res.data.response.forEach(x => {
                            this.branchs.push(x);
                        });
                    });
                }
            },
            updateDept() {
                if (this.branchs.length && this.branchs) {
                    this.departments = [];
                    this.branchs.forEach(x => {
                        x.departments.forEach(i => {
                            this.departments.push(i);
                        });
                    });
                }
            },
            clearData() {
                this.branchName = [];
                this.departmentName = [];
            },
            yearNext() {
                let year = this.years_to_set[5];
                this.years_to_set = [];
                for (let i = 0; i < 6; i++) {
                    this.years_to_set.push(year + i);
                }
            },
            yearPrev() {
                let year = this.years_to_set[0];
                this.years_to_set = [];
                for (let i = 0; i < 6; i++) {
                    this.years_to_set.push(year - i);
                }
                this.years_to_set.reverse();
            },
            yearClicked(startyear, endyear) {
                if (this.fiscalYear == startyear + "-" + endyear) {
                    this.fiscalYear = ""
                } else {
                    this.fiscalYear = startyear + "-" + endyear;
                };
            },
            dropdownTriggered(event) {
                if (!event) {
                    this.selectedFilter = "";
                }
                if (event) {
                    this.hide_el_dropdown = false;
                }
            },
            async fetchCustomers(key) {
                let search = "";
                if (key) {
                    search = key;
                }
                this.customers = [];
                let response = await this.getCustomers({
                    skip: 0,
                    limit: this.limit,
                    search_key: search,
                });
                this.customers = response.response;
            },
            getFilteredListData() {
                this.hide_el_dropdown = true;
                this.getListData();
            },
            viewCompany(_id) {
                this.$store.commit("setCompanyToView", _id);
                this.$router.push("/listsalesforecastfiltered");
            },
            editCompany(_id) {
                this.$store.commit("setCompanyToView", _id);
                this.$router.push("/listsalesforecastfiltered");
            },
            deletSales(_id) {
                this.$swal({
                    title: "WARNING",
                    text: "The Sales Forecast Will Be Deleted",
                    type: "warning",
                    confirmButtonText: "DELETE",
                    showCancelButton: true,
                    cancelButtonText: "CANCEL",
                    confirmButtonColor: "#005dae",
                }).then(result => {
                    if (result.value) {
                        this.deletSalesConfirm(_id);
                    }
                });
            },
            removeCompany(company) {
                this.selectCompany = this.selectCompany.filter(x => x != company);
            },
            removeBranch(branch) {
                this.branchName = this.branchName.filter(x => x != branch);
            },
            removeDepartment(department) {
                this.departmentName = this.departmentName.filter(x => x != department);
            },
            removeSalesPerson(salesPerson) {
                this.salesPerson = this.salesPerson.filter(x => x != salesPerson);
            },
            removeAllFilters() {
                this.selectCompany = [];
                this.branchName = [];
                this.departmentName = [];
                this.salesPerson = [];
                this.fiscalYear = "";
            },
            async deletSalesConfirm(_id) {
                let res = await this.$http.post("/sales_forecast/delete_sales", {
                    _id: _id,
                });
                if (res.data.status_id == 1) {
                    this.$awn.success("Sales Forecast Deleted Successfully");
                }
                this.getListData();
            },
            async fetchSalesPerson(key) {
                if (key) {
                    this.search_key = key;
                }
                let params = {
                    search_key: this.search_key,
                    skip: 0,
                    limit: this.limit,
                    company_id: this.account._id,
                    active_status: "active",
                };
                let res = await this.$http.post("employees/get_employees", params);
                if (res.data.status_id == 1) {
                    this.salesperson = [];
                    res.data.response.forEach(x => {
                        this.salesperson.push(x);
                    });
                }
            },
            async fetchSalesPersonAfter(reached) {
                if (reached) {
                    this.skip = this.salesperson.length;
                    let search = "";
                    let params = {
                        search_key: this.search_key,
                        skip: this.skip,
                        limit: this.limit,
                        company_id: this.account.company_id,
                        active_status: "active",
                    };
                    let res = await this.$http.post("employees/get_employees", params);
                    if (res.data.status_id == 1) {
                        res.data.response.forEach(x => {
                            this.salesperson.push(x);
                        });
                    }
                };
            },
            async getListData() {
                this.ajaxCallinprogress = true;
                let params = {
                    filter_json: {},
                    skip: this.skip,
                    limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                    search_key: this.search_key,
                };
                if (this.selectCompany && this.selectCompany.length) {
                    Object.assign(params.filter_json, {
                        customer_id: [...new Set(this.selectCompany.map(x => x._id))],
                    });
                }
                if (this.fiscalYear) {
                    Object.assign(params.filter_json, {
                        target_year: this.fiscalYear
                    });
                }
                if (this.branchName && this.branchName.length) {
                    Object.assign(params.filter_json, {
                        branch: [...new Set(this.branchName.map(x => x._id))],
                    });
                }
                if (this.salesPerson && this.salesPerson.length) {
                    Object.assign(params.filter_json, {
                        sales_person: [...new Set(this.salesPerson.map(x => x._id))],
                    });
                }
                if (this.departmentName && this.departmentName.length) {
                    Object.assign(params.filter_json, {
                        department: this.departmentName
                    });
                }
                let res = await this.$http.post("/sales_forecast/list", params);
                if (res.data.status_id == 1) {
                    this.listTable = res.data.response.sales;
                }
                this.total = res.data.count;
                this.start = this.total == 0 ? 0 : this.count * this.limit + 1;
                let temp = this.count * this.limit + this.limit;
                this.end = temp < this.total ? temp : this.total;
                this.ajaxCallinprogress = false;
            },
            previousPage() {
                this.temp_total = 0
                this.skip_temp = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.getListData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.getListData();
            },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = this.limit
                this.getListData();
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.getListData();
            },
            getCallReportList(param) {
                if (param == "prev") this.count--;
                else if (param == "next") this.count++;
                else if (param == "init") {
                    this.count = 0;
                } else if (param == "searchKey") {
                    this.count = 0;
                }
                this.getListData();
            },
        },
        mounted() {
            this.fetchCustomers();
            this.getListData();
            this.fetchSalesPerson();
        },
        created() {
            for (let i = 0; i < 6; i++) {
                let year = new Date().getFullYear();
                this.years_to_set.push(year + i);
            }
        },
        watch: {
            search_key: function () {
                this.getListData();
            }
        },
        computed: {
            account() {
                return this.$store.getters.selectedCompany;
            },
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        },
    };
</script>

<style scoped>
    .fiscal-year-el.el-dropdown-menu {
        width: 200px;
    }

    .router {
        min-height: 34px;
        min-width: 35px !important;
        border-radius: 9px;
        background-color: grey;
    }

    .fiscal-year-el.el-icon-arrow-down {
        font-size: 12px;
    }

    .head {
        background-color: #005dae;
    }

    .filers_added {
        background: #d0e8ff;
        border-radius: 8px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 15px;
        width: fit-content;
        margin-left: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListSalesForecast.vue